<div class="container" *ngIf="isDataAvailable">
  <!-- <h2>{{ resetPassContent.data[0].heading }}</h2> -->

  <div *ngIf="!submitted || status == ''; then thenBlock; else elseBlock"></div>
  <!-- <p class="para">{{ sitecoreContent.text }}</p> -->
  <!-- <ng-template #thenBlock class="para">{{ sitecoreContent.text }}</ng-template>
  <ng-template #elseBlock class="para">Check {{email}} for the email with a link to reset your password.</ng-template>
  <br/><br/> -->
  <ng-template #thenBlock>
    <p class="intro">{{ resetPassContent.data[0].description }}</p>

    <p class="sub-tittle">{{ resetPassContent.data[0].text }}</p>
    <ul class="list">
      <div *ngFor="let item of resetPassContent.data[0].displayItems; let count=index;">
        <li *ngIf="(count != 5 && count != 6)">
          {{item.description}}
        </li>
      </div>
    </ul>
    <ul class="list margin-top">
      <li *ngFor="let item of resetPassContent.messages[0].displayItems">
        {{ item.description }}
      </li>
    </ul>
  </ng-template>
  <ng-template #elseBlock>
    <div
      *ngIf="submitted && status == 'Success'; then thenBlock2; else elseBlock2"
    ></div>
    <ng-template #thenBlock2>
      Your password has successfully been updated.
    </ng-template>
    <ng-template #elseBlock2>
      Your password was not reset. Please try again or contact us at
      <br/>
      <span>
        Email
        <a href={{resetPassContent.data[0].displayItems[5].description}}>
          {{resetPassContent.data[0].displayItems[5].keyText}}
        </a>
        or Phone
        <a href={{resetPassContent.data[0].displayItems[6].description}}>
          {{resetPassContent.data[0].displayItems[6].keyText}}
        </a>
        .
      </span>
    </ng-template>
    <br /><br />
  </ng-template>

  <form
    *ngIf="!submitted || status == ''"
    [formGroup]="resetPassword"
    (submit)="onSubmit()"
  >
    <div class="frm-field">
      <label for="password"
        >{{ formFields?.passwordField?.fieldInfo.label }}<span>*</span>:</label
      >
      <input
        type="password"
        id="password"
        formControlName="password"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
      />
      <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
        <div *ngIf="f.password.errors.required">
          {{ formFields?.passwordField?.fieldInfo.label }}
          {{ f.password['requiredError'] }}
        </div>
        <div *ngIf="f.password.errors.minlength">
          {{ f.password['minLengthError'] }}
        </div>
        <div *ngIf="f.password.errors.maxlength">
          {{ f.password['maxLengthError'] }}
        </div>
        <div *ngIf="f.password.errors.isValid">
          <div *ngIf="f.password.errors.message === 'formatError'">
            {{ f.password['passwordFormatError'] }}
          </div>
          <div *ngIf="f.password.errors.message === 'userNameError'">
            {{ f.password['passwordUserNameError'] }}
          </div>
          <div *ngIf="f.password.errors.message === 'userEmailError'">
            {{ f.password['passwordEmailError'] }}
          </div>
        </div>
      </div>
    </div>

    <div class="frm-field">
      <label for="confirmPassword"
        >{{ formFields?.confirmPasswordField?.fieldInfo.label
        }}<span>*</span>:</label
      >
      <input
        type="password"
        id="confirmPassword"
        formControlName="confirmPassword"
        class="form-control"
        [ngClass]="{
          'is-invalid': submitted && f.confirmPassword.errors
        }"
      />
      <div
        *ngIf="submitted && f.confirmPassword.errors"
        class="invalid-feedback"
      >
        <div *ngIf="f.confirmPassword.errors.required">
          {{ formFields?.confirmPasswordField?.fieldInfo.label }}
          {{ f.confirmPassword['requiredError'] }}
        </div>
        <div
          *ngIf="
            f.confirmPassword.value !== f.password.value &&
            f.confirmPassword.value
          "
        >
          {{ f.confirmPassword['matchError'] }}
        </div>
      </div>
    </div>

    <div class="top-margin20">
      <button type="button" class="btn-secondary cancel" (click)="cancel()">
        CANCEL
      </button>
      <button class="btn-primary send">SUBMIT</button>
    </div>
  </form>
</div>
<div class="footer-line"></div>
